module.exports = __webpack_public_path__ + "img/shelf_fade.94118ae7.svg";